import ButtonsSubmitCancel from './ButtonsSubmitCancel-redux';

export default ButtonsSubmitCancel;
